/** Conversation Members limit for RTActions  */
export const RTACTIONS_MEMBERS_LIMIT = 15

/** Fail to Retrieve the RTConversation id from the legacy URI of the conversation after the migration */
export const ERROR_LEGACY_DM_KO = 'ERROR_LEGACY_DM_KO'
